import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const entityMasterService = createApi({
    reducerPath: 'entityMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Entity'],
    endpoints: (builder) => ({
        getAllEntityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.getAllEntityMaster}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getEntityMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.getEntityMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveEntityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.saveEntityMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateEntityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.updateEntityMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteEntityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.deleteEntityMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllEntityMasterBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.entityMasterController.getAllEntityMasterBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllEntityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.findAllEntityMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveEntityMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.bulkSaveEntityMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        getDueDiligence: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.getDueDiligence}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        downloadReport: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityMasterController.downloadReport}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                    responseHandler: (response) => response.blob(),
                    responseType: 'blob',
                }
            }
        }),
    })
});
export const {
    useGetAllEntityMasterMutation,
    useGetEntityMasterByIdMutation,
    useSaveEntityMasterMutation,
    useUpdateEntityMasterMutation,
    useDeleteEntityMasterMutation,
    useGetAllEntityMasterBySearchMutation,
    useFindAllEntityMasterMutation,
    useBulkSaveEntityMasterMutation,
    useGetDueDiligenceMutation,
    useDownloadReportMutation
} = entityMasterService;